import React from 'react';
import {
  SuccessRegistrationContainer,
  SuccessRegistrationContent,
  CardWithRules,
  ConfirmButtonMargin,
} from './styles';
import { Keycard } from './keycard';
import { HowToUse } from './how-to-use';
import { RegularButton } from 'fronton-react';
import { sendYourCardCompleteEvent } from 'utils/ga-events';
import { useBreakpoints, useEffectOnce } from 'common/hooks';
import { EKeycardType } from 'reducers/loyalty-registration-modal-reducer';
import { useTranslation } from 'react-i18next';

interface ISuccessRegistration {
  keycardType: EKeycardType;
  cardNumber: string;
  onClose: () => void;
}

export const SuccessRegistration: React.FC<ISuccessRegistration> = ({
  keycardType,
  cardNumber,
  onClose,
}) => {
  const { t } = useTranslation();
  const { mobile } = useBreakpoints() || {};

  useEffectOnce(() => {
    sendYourCardCompleteEvent(keycardType);
  });

  return (
    <SuccessRegistrationContainer data-qa="loyalty-registration-modal-success-step">
      <SuccessRegistrationContent>
        <CardWithRules>
          <Keycard cardNumber={cardNumber} keycardType={keycardType} />
          <HowToUse />
        </CardWithRules>
        {!mobile && (
          <RegularButton
            data-qa="modal-close-button"
            className={ConfirmButtonMargin}
            wide
            variant="secondary"
            size="l"
            onClick={onClose}
          >
            {t('loyalty-registration-modal.success-step.excellent')}
          </RegularButton>
        )}
      </SuccessRegistrationContent>
    </SuccessRegistrationContainer>
  );
};
